import script from "./ChangeEmailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeEmailModal.vue?vue&type=script&setup=true&lang=js"

import "./ChangeEmailModal.vue?vue&type=style&index=0&id=0377cb1f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0377cb1f"]])

export default __exports__